import { Component, Inject, inject } from '@angular/core';
import { DokumentacijaHierarhijaComponent } from '@app/components/dokumentacija/dokumentacija-hierarhija.component';
import { FQAN_jedgrad_id } from '@app/components/hierarhija/hierarhija.component';
import { ParentListViewProvider } from '@app/components/pretraga-kataloga/providers/parent-list-view.provider';
import { TreeViewProviderDirective } from '@app/providers';
import {
  ItemActionComponent,
  ItemActionResult,
  ItemProvider,
  NotificationService
} from '@ntap/core';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'app-locate-in-doc-tree',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class LocateInDokumentacijaTreeActionComponent extends ItemActionComponent {
  constructor(
    protected override notificationService: NotificationService,
    protected override itemProvider: ItemProvider,
    @Inject(DokumentacijaHierarhijaComponent)
    private parentComponent: DokumentacijaHierarhijaComponent
  ) {
    super(notificationService, itemProvider);
  }

  private parentListView = inject(ParentListViewProvider);

  protected override doExecuteWithItem(
    item: any
  ): Observable<ItemActionResult> {
    if (this.parentListView instanceof TreeViewProviderDirective) {
      const id = item[FQAN_jedgrad_id];
      this.parentComponent.findNodePath(id);
    }
    return of();
  }
}
